angular.module('mtic.components.modules.moduleIframe').
directive('moduleIframe', function (
  $log,
  api,
  $sce,
  language,
  EventManager,
  StudentDataService,
  apiMethods
  ) {
    return {
      templateUrl: 'template.html',
      restrict: 'E',
      scope: {
        moduleMapData: "=",
        moduleId: "=",
        iframeScroll: '=?'
      },
      link: function (scope, element, attr) {
        scope.iframeScroll = scope.iframeScroll || 'no';

        var eventManager = new EventManager('moduleIframe', scope);
        scope.language = language;
        var url = scope.moduleMapData.hostUrl;
        if(!url) {
          url = StudentDataService.genUrlfromContent(scope.moduleMapData.slug, scope.moduleMapData.content);
        }

        scope.src = $sce.trustAsResourceUrl(url);
        /**
        * Broadcast to child iframe
        * @param  {String} type
        * @param {Object} payload
        * @return {null}
        */
        var broadcastToIframe = function (type, payload) {
          $log.debug('[[broadcastToIframe]]',type,payload)
          document.getElementById('moduleIframe').contentWindow.postMessage(
            JSON.stringify({
              type: type,
              payload: payload
            }),
            document.getElementById('moduleIframe').src
            )
          }

          /**
          * A flag indicating that the postMessageHandler is Sending
          * @type {Boolean}
          */
          var postMessageHandlerLastSentTime = 0;
          var submitting;

          var eventListeners = [
            {
              eventName : "language:change",
              listener  : function (e, eventData) {
                broadcastToIframe('LANGUAGE_CHANGE', eventData)
              }
            },
            {
              eventName : "moduleIframe:RESOURCE_OPENED",
              listener  : function (e, eventData) {
                broadcastToIframe('RESOURCE_MODULE_DATA_SENT', {
                  slug: scope.moduleMapData.slug,
                  id: scope.moduleMapData.id,
                  resources: scope.moduleMapData.resources
                })
              }
            },
            {
              eventName : "moduleIframe:RESOURCE_LOAD_COMPLETE",
              listener  : function (e, eventData) {
                broadcastToIframe('LANGUAGE_CHANGE', language.getCurrentSelectedLanguage());
                //run_like_math levels
                if (eventData && eventData.payload && eventData.payload.module_id === 2) {
                  eventManager.broadcast('resource:load:complete');
                  eventManager.broadcast('mticResource:RESOURCE_LOAD_COMPLETE', eventData.payload);
                }
              }
            },
            /**
            * Modules like c3_m2 (run_like_math) are loaded as a single resource (a module map and collection of lessons).
            * This signal should be invoked when a lesson is opened from that map.
            * Otherwise there is no evidence that lessons are being accessed in the module.
            **/
            {
              eventName : "moduleIframe:OPENING_RESOURCE",
              listener  : function (e, eventData) {
                eventData.payload.url = true;
                eventManager.broadcast('module:open:resource', eventData.payload);
              }
            },
            {
              eventName : "moduleIframe:CLOSING_RESOURCE",
              listener  : function (e, eventData) {
                eventManager.broadcast('module:close:resource', {isPassive:true});
                $log.log('HERRRRRRRRRREEEEEE')
              }
            },
            {
              eventName : "moduleIframe:CHANGE_SUBMODULE",
              listener  : function (e, eventData) {
                eventManager.broadcast('module:change:submodule', eventData.payload.slug);
              }
            },
            {
              eventName : "moduleIframe:REQUEST_REFRESH",
              listener  : function (e, eventData) {
                var src = scope.src;
                scope.src = null;
                StudentDataService.getModuleData(true)
                .then(function(moduleMapData){
                  scope.src = src;
                  eventManager.broadcast('app:module:refresh');
                  document.getElementById('moduleIframe').contentWindow.location.reload();
                });
              }
            },
            {
              eventName : "moduleIframe:RESOURCE_REFRESH_REQUEST",
              listener  : function (e, eventData) {
                // $log.log('moduleIframe:RESOURCE_REFRESH_REQUEST', eventData);
                eventManager.broadcast('app:module:refresh'); // TO DO : watch for race condition, this is a fairly loose trigger which is not defending against the user navigating to something else
              }
            },
            {
              eventName : "app:module:refresh/ready",
              listener  : function (e, eventData) {
                // $log.log('app:module:refresh/ready', eventData);
                broadcastToIframe('RESOURCE_REFRESH_READY', {})
              }
            },
            {
              eventName: "module:updateAndClose:resource",
              listener : function (e, eventData) {
                broadcastToIframe('REQUEST_ITEM_PROGRESS', eventData);
              }
            },
            {
              eventName : "moduleIframe:ITEM_PROGRESS",
              listener  : function (e, payload) {
                if(submitting){
                  return;
                }
                submitting = true;
                if(!payload.payload){
                  var payload_copy = angular.copy(payload);
                  payload.payload = payload_copy;
                  payload.payload.complete = payload.payload.complete ? payload.payload.complete : payload.completed;
                  payload.payload.id = payload.payload.id === undefined ? scope.moduleMapData.id : payload.payload.id;
                }
                // $log.log('from moduleiframe, reporting progress : ', payload)
                var mod_id = scope.moduleId;
                if(payload.slug === 'mtic_student_offboarding' || payload.slug === 'mtic_teacher_offboarding' || payload.slug === 'mtic_post_test'){
                  mod_id = 57;
                }
                if(payload.payload.app_state){
                  payload.payload.app_state.assessment_session_hash = eventManager.getResourceSession();
                  $log.log('got resource session : ' , payload.payload.app_state.assessment_session_hash)
                }
                return api.submitStudentResourceState({
                  "slug": payload.payload.slug,
                  "score": payload.payload.score,//Math.max(0,Math.min(1,payload.payload.score)),
                  "complete": payload.payload.complete,
                  "time_spent": payload.payload.time_spent,
                  "time_stamp": payload.payload.time_stamp,
                  "log_data": payload.payload.log_data || {},
                  "app_state": payload.payload.app_state || {},
                  "resource_id": payload.payload.id,
                  "module_id": mod_id,
                  "class_id": scope.moduleMapData.class_id
                }).then(function (response) {
                  submitting = false
                  eventManager.broadcast('resource:score:submitted', {
                    "attemptNumber": response.attempts,
                    "work_batch_id": response.work_batch_id,
                    "score": payload.payload.score,
                    "complete": payload.payload.complete,
                  })
                }, function (error) {
                  submitting = false
                  $log.error('Failed to update the state', error)
                })
                // }
              }
            },
            {
              eventName : "$messageIncoming",
              /**
              * A global listener, that handles events coming from the app
              * @param  {Event} event
              * @param  {Object} itemProgressPayload
              */
              listener  : function (event, msgPayload) {
                var timeSince = Date.now() - postMessageHandlerLastSentTime
                $log.debug('$messageIncoming', {
                  msgPayload: msgPayload,
                  currentResource: scope.currentResource
                })
                if (timeSince < 3 * 1000) {
                  $log.warn('postMessageHandlerIsSending is being sent very rapidly! timeSince:', timeSince + 'ms')
                }
                postMessageHandlerLastSentTime = Date.now()
                if (msgPayload.type) {
                  eventManager.broadcast('moduleIframe:' + msgPayload.type, msgPayload.payload)
                } else {
                  $log.error('No Event Type coming from resource!')
                }
              }
            },
          ];

          var listenerDeregisters = [];
          eventListeners.forEach(function(eventListener){
            var listener = eventManager.listen(eventListener.eventName, eventListener.listener);
            listenerDeregisters.push(listener);
          });

          scope.$on('$destroy', function(){
            eventManager.broadcast('module:reload:map')
            listenerDeregisters.forEach(function(listenerDeregister){
              listenerDeregister();
            })
          });

        }
      }
    });
